import { z } from 'zod'

export const WeekDays = z.enum([
  'SUNDAY',
  'MONDAY',
  'TUESDAY',
  'WEDNESDAY',
  'THURSDAY',
  'FRIDAY',
  'SATURDAY'
])
export type WeekDays = z.infer<typeof WeekDays>
